export default function addProject(state, action) {
  const { project: { _id, title, createdAt, updatedAt, cameras, entities: { doorControllers, doors, networkClosets, wiredDevices } } } = action

  const newProject = {
    id: _id,
    title,
    createdAt,
    updatedAt,
    deviceCount: cameras.filter(c => !c.imagerId).length + doorControllers.allIds.length + doors.allIds.length + networkClosets.allIds.length + wiredDevices.allIds.length
  }

  return Object.assign({}, state, {
    projects: state.projects.concat(newProject)
  })
}



// WEBPACK FOOTER //
// ./src/reducers/addProject.js